import controller from './month-navigator-controller';
import template from './month-navigator.html';

const MonthNavigatorComponent = {
    bindings: {
        initialMonth: '<',
        initialYear: '<',
        firstYear : '<',
        finalYearOffset : '<',
        showIcon : '<',
        onDateChange: '&'
    },
    controller,
    template
};

export default MonthNavigatorComponent;



// WEBPACK FOOTER //
// ./app/common/month-navigator/month-navigator-component.js